"use client";
import type { ReactElement } from "react";
import { motion } from "framer-motion";
import { Ctext } from "@/components/ui/Ctext";
import { ColorType, FontWeight } from "@/theme";
interface CwitnessParallaxTextBlockProps {
    isAccent: boolean | undefined;
    size: number;
    text: string;
}
export function CwitnessParallaxTextBlock({ isAccent, size, text, }: CwitnessParallaxTextBlockProps): ReactElement {
    return (
      <motion.div>
        <Ctext size={size} weight={FontWeight.Light} color={isAccent ? ColorType.Accent : ColorType.White} opacity={1} style={{
            lineHeight: 1.7,
            ...(isAccent && {
                fontWeight: FontWeight.Bold,
                textAlign: "center",
                display: "block",
            }),
        }}>
          {text}
        </Ctext>
      </motion.div>
    );
}
